/**
 * Facets Search — UrbanPaw
 * Filters filter option items as the user types in the search box.
 * Works on vertical sidebar (desktop) facet lists.
 *
 * IMPORTANT: The search input is inside Shopify's FacetFiltersForm.
 * We must stop ALL events from bubbling up to the form,
 * otherwise Shopify's facets.js will try to submit a filter with our
 * search text as a filter value and break the URL/page.
 */

(function () {
  'use strict';

  function doFilter(input, list) {
    var query = input.value.trim().toLowerCase();
    var items = list.querySelectorAll('.facets__item');

    items.forEach(function (item) {
      if (!query) {
        item.classList.remove('facets__item--hidden');
        return;
      }
      var textEl = item.querySelector('.facet-checkbox__text-label, .facet-checkbox__text, label');
      var text = textEl ? textEl.textContent.trim().toLowerCase() : '';
      if (text.includes(query)) {
        item.classList.remove('facets__item--hidden');
      } else {
        item.classList.add('facets__item--hidden');
      }
    });

    // When searching, reveal hidden "show-more" items so users can find them
    if (query) {
      list.querySelectorAll('.show-more-item.hidden').forEach(function (el) {
        el.classList.remove('hidden');
        el._shownBySearch = true;
      });
    } else {
      list.querySelectorAll('.show-more-item').forEach(function (el) {
        if (el._shownBySearch) {
          el.classList.add('hidden');
          el._shownBySearch = false;
        }
      });
    }
  }

  function bindSearchInput(input) {
    if (input._facetsSearchBound) return;

    // Find the closest fieldset, then the ul with data-facet-list
    var fieldset = input.closest('fieldset');
    if (!fieldset) return;

    var list = fieldset.querySelector('[data-facet-list]');
    if (!list) return;

    input._facetsSearchBound = true;

    // ── CRITICAL: Stop ALL events from bubbling to Shopify's form in capture phase ──
    var eventsToBlock = ['input', 'change', 'keydown', 'keyup', 'keypress', 'compositionstart', 'compositionend'];
    eventsToBlock.forEach(function (evtName) {
      input.addEventListener(evtName, function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
      }, true); // capture phase — fires BEFORE Shopify's listeners
    });

    // ── Filtering: Listen to multiple events to ensure capture in all browsers ──
    function handleFilter(e) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      doFilter(input, list);
    }

    input.addEventListener('input', handleFilter, true);
    input.addEventListener('keyup', handleFilter, true);

    // Escape to clear
    input.addEventListener('keydown', function (e) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      if (e.key === 'Escape') {
        input.value = '';
        doFilter(input, list);
        input.blur();
      }
      if (e.key === 'Enter') {
        e.preventDefault();
      }
    }, true);

    // Poll-based fallback: if value changes but events don't fire (browser automation), catch it
    var lastValue = '';
    setInterval(function () {
      if (document.body.contains(input) && input.value !== lastValue) {
        lastValue = input.value;
        doFilter(input, list);
      }
    }, 200);
  }

  function init() {
    var inputs = document.querySelectorAll('[data-facet-search-input]');
    inputs.forEach(bindSearchInput);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run after Shopify section loads or AJAX filter updates
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 100);
  });

  // Watch for Shopify AJAX replacing the filter sidebar DOM
  function watchForFacetUpdates() {
    var filterWrapper = document.getElementById('main-collection-filters');
    if (!filterWrapper) return;

    var observer = new MutationObserver(function () {
      setTimeout(init, 100);
    });

    observer.observe(filterWrapper, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForFacetUpdates);
  } else {
    watchForFacetUpdates();
  }

})();
